import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectTripCancellationCFStep = (state) => state.get('tripCancellationCFStep');

const makeSelectTripCancellationCFStep = () => createSelector(
  selectTripCancellationCFStep,
  (selectTripCancellationCFSate) => ({
    tripCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'tripCancellation']),
      ''
    ),

    reasonForTripCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'reasonForTripCancellation']),
      ''
    ),

    companyNameTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'companyNameTravelCancellation']),
      ''
    ),

    addressTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'addressTravelCancellation']),
      ''
    ),

    cityTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'cityTravelCancellation']),
      ''
    ),

    stateTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'stateTravelCancellation']),
      ''
    ),
    zipCodeTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'zipCodeTravelCancellation']),
      ''
    ),

    contactTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'contactTravelCancellation']),
      ''
    ),

    phoneNumberTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'phoneNumberTravelCancellation']),
      ''
    ),

    includedInPackageTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'includedInPackageTravelCancellation']),
      ''
    ),

    dateTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateTravelCancellation']),
      ''
    ),

    reasonForTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'reasonForTravelCancellation']),
      ''
    ),

    nameOfPersonHavingSicknessTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'nameOfPersonHavingSicknessTravelCancellation']),
      ''
    ),

    dateOfBirthTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateOfBirthTravelCancellation']),
      ''
    ),

    relationshipToClaimantTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'relationshipToClaimantTravelCancellation']),
      ''
    ),

    dateSicknessOrInjuryBeganTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateSicknessOrInjuryBeganTravelCancellation']),
      ''
    ),

    dateEndedTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateEndedTravelCancellation']),
      ''
    ),

    natureOfSicknessOrInjuryTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'natureOfSicknessOrInjuryTravelCancellation']),
      ''
    ),

    fromDateTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'fromDateTravelCancellation']),
      ''
    ),

    toDateTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'toDateTravelCancellation']),
      ''
    ),

    dateOfInitialPaymentDepositTravelCancellation: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateOfInitialPaymentDepositTravelCancellation']),
      ''
    ),

    lossInformationItemsTravelCancellation: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'lossInformationItemsTravelCancellation']) && selectTripCancellationCFSate.getIn(['form', 'lossInformationItemsTravelCancellation']).toJS(), ''),
    insuredsTravelCancellation: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'insuredsTravelCancellation']) && selectTripCancellationCFSate.getIn(['form', 'insuredsTravelCancellation']).toJS(), ''),
    enableTimeTravelCancellation: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'enableTimeTravelCancellation']), null),

    // Trip Cancellation for Any Reason
    tripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'tripCancellationForAnyReason']),
      ''
    ),

    companyNameTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'companyNameTripCancellationForAnyReason']),
      ''
    ),

    addressTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'addressTripCancellationForAnyReason']),
      ''
    ),

    cityTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'cityTripCancellationForAnyReason']),
      ''
    ),

    stateTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'stateTripCancellationForAnyReason']),
      ''
    ),
    zipCodeTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'zipCodeTripCancellationForAnyReason']),
      ''
    ),

    contactTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'contactTripCancellationForAnyReason']),
      ''
    ),

    phoneNumberTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'phoneNumberTripCancellationForAnyReason']),
      ''
    ),

    includedInPackageTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'includedInPackageTripCancellationForAnyReason']),
      ''
    ),

    dateTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateTripCancellationForAnyReason']),
      ''
    ),

    reasonForTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'reasonForTripCancellationForAnyReason']),
      ''
    ),

    dateOfInitialPaymentDepositTripCancellationForAnyReason: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateOfInitialPaymentDepositTripCancellationForAnyReason']),
      ''
    ),

    lossInformationItemsTripCancellationForAnyReason: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'lossInformationItemsTripCancellationForAnyReason']) && selectTripCancellationCFSate.getIn(['form', 'lossInformationItemsTripCancellationForAnyReason']).toJS(), ''),
    insuredsTripCancellationForAnyReason: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'insuredsTripCancellationForAnyReason']) && selectTripCancellationCFSate.getIn(['form', 'insuredsTripCancellationForAnyReason']).toJS(), ''),

    // Trip Interruption
    travelInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'travelInterruption']),
      ''
    ),

    addressTravelInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'addressTravelInterruption']),
      ''
    ),

    companyNameTravelInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'companyNameTravelInterruption']),
      ''
    ),

    reasonsForTripInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'reasonsForTripInterruption']),
      ''
    ),

    cityTravelInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'cityTravelInterruption']),
      ''
    ),

    stateTravelInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'stateTravelInterruption']),
      ''
    ),
    zipCodeTravelInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'zipCodeTravelInterruption']),
      ''
    ),

    contactTravelInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'contactTravelInterruption']),
      ''
    ),

    phoneNumberTravelInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'phoneNumberTravelInterruption']),
      ''
    ),

    includedInPackage: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'includedInPackage']),
      ''
    ),

    dateTripInterrupted: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateTripInterrupted']),
      ''
    ),

    reasonForInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'reasonForInterruption']),
      ''
    ),

    nameOfPersonHavingSickness: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'nameOfPersonHavingSickness']),
      ''
    ),

    dateOfBirth: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateOfBirth']),
      ''
    ),

    relationshipToClaimant: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'relationshipToClaimant']),
      ''
    ),

    dateSicknessOrInjuryBegan: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),

    dateEnded: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateEnded']),
      ''
    ),

    natureOfSicknessOrInjury: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'natureOfSicknessOrInjury']),
      ''
    ),

    periodOfHospitalization: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'periodOfHospitalization']),
      ''
    ),

    fromDate: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'fromDate']),
      ''
    ),

    toDate: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'toDate']),
      ''
    ),

    dateOfInitialPaymentDepositForInterruption: mapWithDefault(
      selectTripCancellationCFSate,
      () => selectTripCancellationCFSate.getIn(['form', 'dateOfInitialPaymentDepositForInterruption']),
      ''
    ),

    insuredsForInterruption: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'insuredsForInterruption']) && selectTripCancellationCFSate.getIn(['form', 'insuredsForInterruption']).toJS(), ''),
    enableTimeInterruption: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'enableTimeInterruption']), null),
    lossInformationItems: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'lossInformationItems']) && selectTripCancellationCFSate.getIn(['form', 'lossInformationItems']).toJS(), ''),

    companyNameLoss: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'currentAmountOfLoss']), ''),
    haveYouReceivedReimbursement: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(selectTripCancellationCFSate, () => selectTripCancellationCFSate.getIn(['form', 'enableTime']), null),
  })
);

const makeSelectTripCancellationCFStepErrors = () =>
  createSelector(selectTripCancellationCFStep, (state) => state.get('errors'));

export {
  makeSelectTripCancellationCFStep,
  makeSelectTripCancellationCFStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.TripCancellationStep/selectors.js